import { Box, Container, CssBaseline, Typography } from '@mui/material';
import React, { useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Analytics } from '@vercel/analytics/react';

import CategorySelector from './components/CategorySelector';
import LanguageSelector from './components/LanguageSelector';
import UnitConverter from './components/UnitConverter';
import { useTranslation } from 'react-i18next';

const theme = createTheme({
  palette: {
    primary: {
      main: '#667eea',
      dark: '#764ba2',
    },
    secondary: {
      main: '#f093fb',
    },
    background: {
      default: '#667eea',
    },
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
  },
});

function App() {
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState(null);
  // per-category natural-language inputs
  const [nlInputs, setNlInputs] = useState({});

  const handleNlInputChange = (categoryKey, value) => {
    setNlInputs(prev => ({ ...prev, [categoryKey]: value }));
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          py: { xs: 4, md: 8 },
          px: 2,
          position: 'relative',
        }}
      >
        <LanguageSelector />

        <Container maxWidth="lg">
          <Box textAlign="center" mb={6}>
            <Typography
              variant="h2"
              component="h1"
              sx={{
                color: 'white',
                fontWeight: 700,
                mb: 1,
                fontSize: { xs: '2rem', sm: '3rem', md: '3.5rem' },
                textShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
              }}
            >
              {t('appTitle')}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: 'rgba(255, 255, 255, 0.95)',
                fontWeight: 400,
                fontSize: { xs: '1rem', sm: '1.125rem' },
              }}
            >
              {t('appDescription')}
            </Typography>
          </Box>

          <CategorySelector selectedCategory={selectedCategory} onSelectCategory={setSelectedCategory} />

          {selectedCategory && (
            <UnitConverter
              category={selectedCategory}
              onRequestCategoryChange={setSelectedCategory}
              nlInput={nlInputs[selectedCategory] || ''}
              onNlInputChange={handleNlInputChange}
            />
          )}

          <Box textAlign="center" mt={6} pb={4}>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
              Made with ❤️ for unit conversions worldwide
            </Typography>
          </Box>
        </Container>
      </Box>
      <Analytics />
    </ThemeProvider>
  );
}

export default App;
